const DAY_MS = 24 * 60 * 60 * 1000

// La tabla "alerts" existe en la base de datos pero nada la rellena todavía
// (no hay ningún cron ni proceso en segundo plano). Mientras no exista eso,
// calculamos alertas útiles al vuelo a partir de los datos que ya se cargan
// para la lista de pacientes.
export function computeDerivedAlerts({ goals, allMetrics, dailyLogFechas }) {
  const alerts = []
  const today = new Date()

  const lastLogTime = dailyLogFechas?.length
    ? Math.max(...dailyLogFechas.map(f => new Date(f).getTime()))
    : null
  const diasSinRegistro = lastLogTime != null ? Math.floor((today - lastLogTime) / DAY_MS) : null

  if (diasSinRegistro === null) {
    alerts.push({ tipo: 'sin_registro', nivel: 'aviso', mensaje: 'Todavía no ha registrado ninguna comida' })
  } else if (diasSinRegistro >= 5) {
    alerts.push({ tipo: 'sin_registro', nivel: 'critica', mensaje: `Sin registrar comidas desde hace ${diasSinRegistro} días` })
  } else if (diasSinRegistro >= 3) {
    alerts.push({ tipo: 'sin_registro', nivel: 'aviso', mensaje: `Sin registrar comidas desde hace ${diasSinRegistro} días` })
  }

  if (!allMetrics || allMetrics.length === 0) {
    alerts.push({ tipo: 'sin_registro', nivel: 'aviso', mensaje: 'Sin ninguna medición corporal registrada' })
  }

  if (goals?.tipo && goals.tipo !== 'mantenimiento' && allMetrics?.length >= 2) {
    const conPeso = allMetrics
      .filter(m => m.peso_kg != null)
      .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
    if (conPeso.length >= 2) {
      const first = conPeso[0]
      const last = conPeso[conPeso.length - 1]
      const dias = (new Date(last.fecha) - new Date(first.fecha)) / DAY_MS
      if (dias >= 14) {
        const delta = last.peso_kg - first.peso_kg
        const semanas = Math.round(dias / 7)
        if (goals.tipo === 'deficit' && delta >= 0) {
          alerts.push({ tipo: 'no_progreso', nivel: 'aviso', mensaje: `Sin pérdida de peso en ${semanas} semanas pese al objetivo de déficit` })
        }
        if (goals.tipo === 'superavit' && delta <= 0) {
          alerts.push({ tipo: 'no_progreso', nivel: 'aviso', mensaje: `Sin ganancia de peso en ${semanas} semanas pese al objetivo de superávit` })
        }
      }
    }
  }

  return alerts
}
